import { Injectable } from '@angular/core';
import { GoogleGenAI, Type } from '@google/genai';

@Injectable({
  providedIn: 'root'
})
export class GeminiService {
  private ai: GoogleGenAI;
  private readonly modelName = 'gemini-2.5-flash';

  private companiesResponseSchema = {
    type: Type.OBJECT,
    required: ['source'],
    properties: {
      source: {
        type: Type.ARRAY,
        items: {
          type: Type.OBJECT,
          required: ['Company Name', 'Industry', 'Country/Region', 'How Product Is Used', 'Source', 'Probability'],
          properties: {
            'Company Name': { type: Type.STRING },
            Industry: { type: Type.STRING },
            'Country/Region': { type: Type.STRING },
            'How Product Is Used': { type: Type.STRING },
            Scope: { type: Type.STRING },
            Source: { type: Type.STRING },
            Probability: { type: Type.STRING },
            dateFirstVerified: { type: Type.STRING },
            dateLastVerified: { type: Type.STRING }
          }
        }
      }
    }
  };

  private profilesResponseSchema = {
    type: Type.OBJECT,
    required: ['source'],
    properties: {
      source: {
        type: Type.ARRAY,
        items: {
          type: Type.OBJECT,
          required: ['Name', 'Title','Source'],
          properties: {
            'Name': { type: Type.STRING },
            'Title': { type: Type.STRING },
            'Department': { type: Type.STRING },
            'Level': { type: Type.STRING },
            'Location': { type: Type.STRING },
            'Core Skills': { type: Type.STRING },
            'Source': { type: Type.STRING },
          }
        }
      }
    }
  };


  constructor() {
    this.ai = new GoogleGenAI({
      apiKey: 'AIzaSyCEQ-DkCwkA3ksRpzaNsgB8m1eEfkLADhA' // безопаснее вынести в .env файл сервера
    });
  }

  async analyzePrompt(systemInstruction: string, userPrompt: string, isProfiles: boolean ): Promise<any> {
    const config = {
      thinkingConfig: {
        thinkingBudget: 0,
      },
      responseMimeType: 'application/json',
      responseSchema: isProfiles ? this.profilesResponseSchema : this.companiesResponseSchema,
      systemInstruction: [{
        text: systemInstruction
      }]
    };

    const contents = [
      {
        role: 'user',
        parts: [{ text: userPrompt }]
      }
    ];

    const model = this.ai.models;
    const response = await model.generateContent({
      model: this.modelName,
      config,
      contents
    });


    try {
      return response.text;
    } catch (err) {
      console.error('Error parsing response:', response.data);
      throw new Error('Failed to parse Gemini response');
    }
  }
}
